<!--
* @description  参数1
* @fileName  startedDialog
* @author userName
* @date 2023-12-21 17:53:23
!-->
<template>
  <div id="startedDialog" class="startedDialog">
    <global-login-dialog v-model="$store.getters.startedDialogVisible" @close="closeDialog">
      <template v-slot:title>
        <div class="title-first">Let's get started</div>
        <div class="title-two">Shipping. Simplified.</div>
      </template>
      <template v-slot:body>
        <div v-if="isShow">
          <el-form ref="loginForm1" :model="loginForm1" :rules="loginRules1">
            <el-form-item prop="email">
              <div class="left">Email adress</div>
              <el-input
                ref="email"
                v-model="loginForm1.email"
                placeholder="Enter your email"
                name="email"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="password">
              <div class="left">Password</div>
              <el-input
                ref="password"
                v-model="loginForm1.password"
                placeholder="Password"
                name="password"
                type="password"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>

          </el-form>
          <button class="by-button--primary craetAccount" @click="createAccount()">Create your free
            account</button>
        </div>
        <div v-if="!isShow">
          <el-form ref="loginForm2" :model="loginForm2" :rules="loginRules2">
            <el-form-item prop="firstName">
              <div class="left">First name</div>
              <el-input
                ref="firstName"
                v-model="loginForm2.firstName"
                placeholder="First name"
                name="firstName"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="lastName">
              <div class="left">Last name</div>
              <el-input
                ref="lastName"
                v-model="loginForm2.lastName"
                placeholder="Last name"
                name="lastName"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="companyName">
              <div class="left">Company name</div>
              <el-input
                ref="companyName"
                v-model="loginForm2.companyName"
                placeholder="Company name"
                name="companyName"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
            <el-form-item prop="monthlyInternational">
              <div class="left">Monthly International Freight Shipments</div>
              <el-select
                ref="selectref"
                v-model="loginForm2.monthlyInternational"
                placeholder="Which of the following describes you best?"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in monthlyInternationalOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <button class="by-button--primary craetAccount" @click.stop="SignUp()">Sign up</button>
        </div>
      </template>
      <template v-slot:footer>

        <div class="footer-first">
          By signing up, I accept the <a :href="sysConfig.registerTermsUrl" target="_blank" style="text-decoration: none;"><span>
            Flexshipping terms and conditions.
          </span></a>
        </div>
        <div class="footer-two">
          I agree to receive freight-related updates, industry insights, and marketing communications from the Flexshipping Group. I know I can opt out of these at any time.
        </div>
        <div v-if="isShow" class="footer-tree">
          Have an account? <span @click="toLogin"> Log in</span>
        </div>
      </template>
    </global-login-dialog>
  </div>
</template>

<script>
import {
  RegisterCheck,
  Register
} from '../../api/user.js'
import {
  GetSysConfig
} from '/src/api/base.js'
import {
  message
} from '@/utils/message'
import {
  setCookie
} from '@/utils/cookiejs'
import GlobalLoginDialog from '../../components/Dialog/Dialog.vue'
import md5 from 'js-md5'
export default {
  name: 'StartedDialog',
  components: { // 组件的引用
    GlobalLoginDialog
  },
  props: { // 父辈向子辈传参
  },
  data() {
    return {
      loginForm1: {
        email: '',
        password: ''
      },
      loginRules1: {
        email: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        },
        {
          pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
          message: 'We don’t recognize this email address. Want to try again?',
          trigger: 'blur'
        }
        ],
        password: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        },
        {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,}$/,
          message: 'Password does not comply with regulations',
          trigger: 'blur'
        }
        ]
      },
      loginForm2: {
        firstName: '',
        lastName: '',
        companyName: '',
        monthlyInternational: ''
      },
      loginRules2: {
        firstName: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }, {
          min: 3,
          message: 'Full name is required',
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }, {
          min: 3,
          message: 'Full name is required',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }, {
          min: 3,
          message: 'Company name is required',
          trigger: 'blur'
        }],
        monthlyInternational: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }]
      },
      isShow: true,
      monthlyInternationalOptions: [{
        value: '50+',
        label: '50+'
      },
      {
        value: '10-49',
        label: '10-49'
      },
      {
        value: '2-9',
        label: '2-9'
      },
      {
        value: 'Less than 2',
        label: 'Less than 2'
      },
      {
        value: 'None - I`m a first time shipper',
        label: 'None - I`m a first time shipper'
      },
      {
        value: 'None - I don`t ship freight',
        label: 'None - I don`t ship freight'
      }
      ],
      sysConfig: {}
    }
  },
  computed: { // 计算属性

  },
  watch: { // 监测变化

  },
  created() { // 实例被创建之后执行代码
    GetSysConfig().then(res => {
      if (res.code === 200) {
        this.sysConfig = res.data
      }
    })
  },
  mounted() { // 页面进入时加载内容

  },
  methods: { // 方法
    closeDialog() {
      this.$store.commit('user/STARTED_VISIBLE', false)
    },
    createAccount() {
      this.$refs.loginForm1.validate(valid => {
        if (valid) {
          RegisterCheck(this.loginForm1.email).then(res => {
            if (res.code === 200) {
              if (res.data === true) {
                this.isShow = false
              } else {
                setCookie('token', res.data)
                this.$emit('success')
                this.$store.commit('user/STARTED_VISIBLE', false)
                setTimeout(() => {
                  this.$store.commit('user/SUCCESS_VISIBLE', true)
                }, 0)
              }
            } else {
              message({
                message: res.message,
                type: 'error'
              })
            }
          })
        }
      })
    },
    SignUp() {
      this.$refs.loginForm2.validate(valid => {
        if (valid) {
          var data = {
            email: this.loginForm1.email,
            password: md5(this.loginForm1.password),
            firstName: this.loginForm2.firstName,
            lastName: this.loginForm2.lastName,
            companyName: this.loginForm2.companyName,
            monthlyInternational: this.loginForm2.monthlyInternational
          }
          Register(data).then(res => {
            if (res.code === 200) {
              setCookie('token', res.data)
              this.$emit('success')
              this.$store.commit('user/STARTED_VISIBLE', false)
              setTimeout(() => {
                this.$store.commit('user/SUCCESS_VISIBLE', true)
              }, 0)
            } else {
              message({
                message: res.message,
                type: 'error'
              })
            }
          })
        }
      })
    },
    toLogin() {
      this.$store.commit('user/DIALOG_VISIBLE', true)
      this.$store.commit('user/STARTED_VISIBLE', false)
    }

  }
}
</script>
<style scoped lang='scss'>
	// 选中动态颜色
	$atv-colorBR: #0046b9;
	$stroke-color-index2: #f0f0f0;

	.footer-font {
		font-size: 13px;
		font-family: D, D;
		font-weight: normal;
		color: #333333;
		margin-bottom: 8px;

	}

	.startedDialog {
		.left {
			text-align: left;
		}

		.craetAccount {
			width: 336px;
			height: 40px;
			margin-top: 8px;
		}

		.footer-first,
		.footer-tree {
			@extend .footer-font;

			span {
				color: #027FFC;
				cursor: pointer
			}
		}

		.footer-two {
			@extend .footer-font;
		}

		::v-deep .dialog__wrapper {
			background-color: rgba(0, 0, 0, 0.32);
		}

		::v-deep .dialog {
			//display: flex;
			width: 384px;
			min-height: 482px;
			background: #FFFFFF;
			border-radius: 16px;
			padding: 0;
			box-shadow: none;
			//top: 50%;
			//margin-top: -188px;

		}

		::v-deep .dialog_all {
			box-sizing: border-box;
			width: 344px;
		}

		::v-deep .dialog__header {
			width: 384px;
			height: 88px;
			background: linear-gradient(180deg, rgba(233, 85, 6, 0.06) 0%, rgba(233, 85, 6, 0.12) 100%);
			border-radius: 16px 16px 0px 0px;
			padding: 16px 24px;

			.title-first {
				font-size: 20px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #333333;
				text-align: center;
			}

			.title-two {
				font-size: 14px;
				font-family: D, D;
				font-weight: normal;
				color: #777777;
				text-align: center;
				margin-top: 8px;
			}

		}

		::v-deep .dialog__title {
			line-height: 56px;
		}

		::v-deep .dialog__body {
			padding: 16px 24px 0;

			.el-form-item {
				margin-bottom: 12px !important;
				width: 336px;

				.el-select {
					display: block;
				}
			}
		}

		::v-deep .dialog__footer {
			width: 341px;
			padding: 16px 24px;
			text-align: left;
		}

		::v-deep .dialog__header .dialog__headerbtn {
			position: relative;
			top: -52px;
			right: -168px;
		}
	}
</style>
